import { Typography } from '@euler/app/components/typography';
import { aiColors, tint } from '@euler/app/flows/ai-suite/theme';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { BiDatasetCatalog } from '@euler/model/bi/catalog';
import { BiUploadedDatasetView } from '@euler/model/bi/dataset';
import { BiDatasetRef } from '@euler/model/bi/query';
import { X } from 'lucide-react-native';
import { memo } from 'react';
import { View } from 'react-native';
import { BiButton } from '../../../components/ui/BiButton';
import { QuerySections } from '../QuerySections';
import { BiEditorQuery, biEditorQueryNew } from '../functions/biEditorState';
import { useBiDatasetCatalog } from '../functions/useBiDatasetCatalog';

/** One more dataset of a KPI group: its dataset, measures and filters. */
export const TotalsPart = memo(
  ({
    index,
    part,
    builtin,
    uploaded,
    onChange,
    onRemove,
    onRetryUploads,
  }: {
    /** 0 for the second dataset of the group. */
    index: number;
    part: BiEditorQuery;
    builtin: BiDatasetCatalog[];
    uploaded: BiUploadedDatasetView[] | null;
    onChange: (next: BiEditorQuery) => void;
    onRemove: () => void;
    onRetryUploads: () => void;
  }) => {
    const { rpx } = useResponsiveContext();
    const { state: catalog, retry } = useBiDatasetCatalog(part.dataset, {
      kind: 'ready',
      builtin,
      uploaded,
    });
    // A new dataset starts the part over: its fields are another's.
    const pick = (dataset: BiDatasetRef) =>
      onChange({ ...biEditorQueryNew(), dataset });
    return (
      <View
        style={{
          gap: rpx(18),
          padding: rpx(14),
          borderRadius: rpx(12),
          borderWidth: 1,
          borderColor: tint(aiColors.primary, 0.3),
          backgroundColor: tint(aiColors.primary, 0.03),
        }}
      >
        <View
          style={{
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <Typography.Text medium size={rpx(14)} color={aiColors.foreground}>
            {`第 ${index + 2} 份数据`}
          </Typography.Text>
          <BiButton icon={X} title="移除" tone="quiet" onPress={onRemove} />
        </View>
        <QuerySections
          query={part}
          catalog={catalog}
          builtin={builtin}
          uploaded={uploaded}
          withDimensions={false}
          withSortLimit={false}
          onPick={pick}
          onChange={onChange}
          onRetryUploads={onRetryUploads}
          onRetryCatalog={retry}
        />
      </View>
    );
  },
);
